import { ApiService }           from '../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../app-lite/companies/models/company.messages';
import { CustomerModel }        from '../../app-lite/customers/models/customer';
import { TableService }         from '../../app-lite/table/table.service';

import CustomerHtml  from '../../app-lite/customers/customer.html';
import CustomersHtml from '../../app-lite/customers/customers.html';

export function CustomersStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'CustomersCtrl',
    name       : 'app.customers',
    templateUrl: CustomersHtml,
    url        : '/customers',
    resolve    : {
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      customers      : ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('customers');

        return workshopAPI.stream('/filters', [
          cache.filtering.value ? cache.filtering.value : '*',
          'customers',
          0,
          cache.paging.pageSize   || 10,
          cache.sorting.field     || 'display_name',
          cache.sorting.direction || 'asc',
          !!cache.filtering.archived_only
        ]);
      }
    }
  })
  .state({
    controller: 'CustomerCtrl',
    name      : 'app.customer',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: CustomerHtml,
    url        : '/customer/:id?mobile',
    resolve    : {
      ams_autoclubs  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/ams_autoclubs'),
      company        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      contactMethods : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/preferred_contact_method_types', null, 'contactMethods'),
      customerSources: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/customer_sources', null, 'customerSources'),
      paymentTerms   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('system/payment_term_types', null, 'paymentTerms'),
      priceTypes     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/customer_price_types', null, 'customerPriceTypes'),
      states         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/state_types', null, 'states'),
      statusTypes    : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/invoice_status_types'),
      taxGroups      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/tax_groups'),
      billedCustomers: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/customers/biller_child_list', [
            $stateParams.id,
            0,
            tableApi.getCacheForTable('billedCustomers').paging.pageSize || 5
          ]) : [],
      biller_balance: ( $stateParams: ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/customer/biller_account_balance', $stateParams.id)
          : '',
      biller_credit_balance: ( $stateParams: ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/customer/biller_credit_balance', $stateParams.id )
          : '',
      customer: ( $stateParams: ng.ui.IStateParamsService, workshopAPI : ApiService ) : Promise<CustomerModel> => {
        return $stateParams.id
          ? workshopAPI.get('/customer', $stateParams.id)
          : Promise.resolve(null);
      },
      events: ( $stateParams: ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('customerEvents');
        const id    = $stateParams.id;

        return id ? workshopAPI.get('/customers/event_list', [
          id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'event_date',
          cache.sorting.direction || 'desc'
        ]) : [];
      },
      inspections: ( $stateParams: ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('customerInspections');
        const id    = $stateParams.id;

        return id ? workshopAPI.get('/customers/inspection_list', [
          id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'inspection_date',
          cache.sorting.direction || 'asc'
        ]) : [];
      },
      invoices: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('customerInvoices');
        const id    = $stateParams.id;

        return id ? workshopAPI.get('/customers/invoice_list_with_find', [
          id,
          0,
          cache.paging.pageSize   || 5,
          cache.filtering.status_type ? cache.filtering.status_type : '*',
          '*',
          cache.filtering.begin_date  ? cache.filtering.begin_date  : '*',
          cache.filtering.end_date    ? cache.filtering.end_date    : '*',
          cache.sorting.field     || 'post_date',
          cache.sorting.direction || 'desc',
          cache.filtering.reference   ? cache.filtering.reference   : '*'
        ]) : [];
      },
      payments: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('customerPayments');
        const id    = $stateParams.id;

        return id ? workshopAPI.get('/customers/payment_list', [
          id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'post_date',
          cache.sorting.direction || 'asc'
        ]) : [];
      },
      quotes: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('customerQuotes');
        const id    = $stateParams.id;

        return id ? workshopAPI.get('/customers/quote_list_with_find', [
          id,
          0,
          cache.paging.pageSize   || 5,
          cache.filtering.begin_date  ? cache.filtering.begin_date  : '*',
          cache.filtering.end_date    ? cache.filtering.end_date    : '*',
          cache.sorting.field     || 'post_date',
          cache.sorting.direction || 'desc',
          cache.filtering.reference   ? cache.filtering.reference   : '*'
        ]) : [];
      },
      vehicles: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('customerVehicles');
        const id    = $stateParams.id;

        return id ? workshopAPI.get('/customers/vehicle_list', [
          id,
          0,
          cache.paging.pageSize   || 5,
          cache.sorting.field     || 'plate_number',
          cache.sorting.direction || 'asc'
        ]) : [];
      }
    }
  });
}